/**
 * 英文
 */
export default {
  message: {
    hello: 'hello world'
  }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/i18n/en.js